import { DISPOSABLE_BLOCKED_MESSAGE, INVALID_EMAIL_MESSAGE } from '@applicator/shared'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000'

export type ValidateSignupEmailResult =
  | { ok: true }
  | { ok: false; message: string }

export async function validateSignupEmail(email: string): Promise<ValidateSignupEmailResult> {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/auth/validate-email`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    })

    if (!response.ok) {
      return { ok: false, message: 'Could not verify email. Try again in a moment.' }
    }

    const payload = (await response.json()) as {
      ok?: boolean
      message?: string | null
      reason?: 'invalid' | 'disposable' | null
    }

    if (payload.ok) {
      return { ok: true }
    }

    if (payload.reason === 'disposable') {
      return { ok: false, message: payload.message || DISPOSABLE_BLOCKED_MESSAGE }
    }

    return { ok: false, message: payload.message || INVALID_EMAIL_MESSAGE }
  } catch {
    return { ok: false, message: 'Could not verify email. Check your connection and try again.' }
  }
}
